
export class CopyUtils {
    static shallowCopy<T>(object: T): T {
        return Object.assign({}, object);
    }

    static deepCopy<T>(object: T): T {
        return JSON.parse(JSON.stringify(object));
    }
}